import { render, staticRenderFns } from "./recommendAdvertListV2.vue?vue&type=template&id=ef4a1cb8&scoped=true"
import script from "./recommendAdvertListV2.vue?vue&type=script&lang=ts"
export * from "./recommendAdvertListV2.vue?vue&type=script&lang=ts"
import style0 from "./recommendAdvertListV2.vue?vue&type=style&index=0&id=ef4a1cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4a1cb8",
  null
  
)

export default component.exports